import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from 'components/ui/button';
import { ROUTES } from 'constants/routes';

export default function Admin() {
  const { t } = useTranslation('common');
  return (
    <main className="flex min-h-screen items-center justify-center bg-[var(--rely-surface-page)] px-4 py-12 text-[var(--rely-text-strong)]">
      <section aria-labelledby="legacy-admin-title" className="w-full max-w-lg space-y-5 rounded-[var(--rely-radius-panel)] border border-[var(--rely-border-subtle)] bg-[var(--rely-surface-panel)] p-6 sm:p-8">
        <h1 id="legacy-admin-title" className="text-2xl font-semibold">
          {t('legacyAdminPanel.title')}
        </h1>
        <p className="text-sm text-[var(--rely-text-muted)]">
          {t('legacyAdminPanel.description')}
        </p>
        <Button variant="primary" asChild>
          <Link to={ROUTES.HOME}>{t('legacyAdminPanel.home')}</Link>
        </Button>
      </section>
    </main>
  );
}
